/**
 * Reown AppKit Configuration
 * Multi-chain wallet connection supporting EVM chains, Solana, and Bitcoin
 */
import { cookieStorage, createStorage, http } from 'wagmi';
import { mainnet, polygon, arbitrum, base } from 'wagmi/chains';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';

// Project ID from Reown Dashboard (https://cloud.reown.com)
// Using a demo project ID - replace with your own for production
export const projectId = process.env.REACT_APP_REOWN_PROJECT_ID || 'd2a7b492aaf665270f1f00afb2f76bfa';

// Supported networks
export const networks = [polygon, base, arbitrum, mainnet];

// Metadata for the wallet connection modal
export const metadata = {
  name: 'Hodler Inn',
  description: 'Crypto-friendly hotel payments',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://hodlerinn.com',
  icons: ['https://avatars.githubusercontent.com/u/179229932'],
};

// Create Wagmi adapter for EVM chains with error handling
let wagmiAdapter = null;
try {
  wagmiAdapter = new WagmiAdapter({
    storage: createStorage({
      storage: typeof window !== 'undefined' ? cookieStorage : undefined,
    }),
    ssr: false,
    projectId,
    networks,
    transports: {
      [mainnet.id]: http(),
      [polygon.id]: http(),
      [arbitrum.id]: http(),
      [base.id]: http(),
    },
  });
} catch (error) {
  console.error('[Reown] Failed to create WagmiAdapter:', error);
}

export { wagmiAdapter };

// Merchant wallet addresses
export const MERCHANT_WALLETS = {
  // EVM chains (same address works on all EVM chains)
  ethereum: '0xC7F5378a1B801a8f384f8e3759D0242dd5cE650A',
  polygon: '0xC7F5378a1B801a8f384f8e3759D0242dd5cE650A',
  arbitrum: '0xC7F5378a1B801a8f384f8e3759D0242dd5cE650A',
  base: '0xC7F5378a1B801a8f384f8e3759D0242dd5cE650A',
  // Non-EVM chains
  bitcoin: 'bc1qr0k84wsj5ckk7ln483ywera7n0py6pt0zar3u2',
  solana: 'Fk5jFAsDWGBg8UPtBWZSqVjc59uiPS3A76WfxtQtybRa',
  tron: 'TUYUQMd1u1J95q3JjriwaZLbaigXMu9ppc',
};

// Token contract addresses per chain
export const TOKEN_CONTRACTS = {
  polygon: {
    USDC: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    USDT: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
  },
  base: {
    USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  },
  arbitrum: {
    USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    USDT: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
  },
  ethereum: {
    USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  },
};

// Chain ID to name mapping
export const CHAIN_NAMES = {
  1: 'ethereum',
  137: 'polygon',
  42161: 'arbitrum',
  8453: 'base',
};

// Network display info
export const NETWORK_INFO = {
  polygon: { name: 'Polygon', icon: '🟣', fees: 'Very Low', chainId: 137, recommended: true },
  base: { name: 'Base', icon: '🔵', fees: 'Low', chainId: 8453 },
  arbitrum: { name: 'Arbitrum', icon: '🔷', fees: 'Low', chainId: 42161 },
  ethereum: { name: 'Ethereum', icon: '⟠', fees: 'High', chainId: 1 },
};
